import { render } from "./Content.vue?vue&type=template&id=5b8c37bf"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
script.render = render

export default script